import React from "react";
import { useTranslation } from "react-i18next";
import LayoutSettings from "@/components/ui/layout-settings";
import type { ReportColumnDescriptor } from "../hooks/useReportTableSettings";

interface ReportColumnSettingsProps {
  descriptors: ReportColumnDescriptor[];
  isSaving?: boolean;
  isCustomized?: boolean;
  onToggle: (key: string) => void;
  onMove: (key: string, direction: "up" | "down") => void;
  onReset: () => void;
}

/**
 * Rapor tablosu kolon ayarları (R11).
 *
 * Görsel/etkileşim mantığı `LayoutSettings` ile ortaktır — gösterge panelindeki
 * widget düzeni de aynı bileşeni kullanır. Burada yalnızca rapor bağlamına ait
 * etiketler ve kolon tanımlayıcıları eşlenir.
 */
const ReportColumnSettings: React.FC<ReportColumnSettingsProps> = ({
  descriptors,
  isSaving = false,
  isCustomized = false,
  onToggle,
  onMove,
  onReset,
}) => {
  const { t } = useTranslation();
  const visibleCount = descriptors.filter((d) => d.visible).length;

  return (
    <LayoutSettings
      buttonLabel={t("reportSettings.columnsButton")}
      panelTitle={t("reportSettings.columnsTitle")}
      hint={t("reportSettings.columnsHint", {
        visible: visibleCount,
        total: descriptors.length,
      })}
      items={descriptors.map((d) => ({
        key: d.key,
        label: d.label,
        visible: d.visible,
        locked: d.alwaysVisible,
      }))}
      isSaving={isSaving}
      isCustomized={isCustomized}
      onToggle={onToggle}
      onMove={onMove}
      onReset={onReset}
    />
  );
};

export default ReportColumnSettings;
